import { render, staticRenderFns } from "./DeleteLecturerModal.vue?vue&type=template&id=11f3ee87&"
import script from "./DeleteLecturerModal.vue?vue&type=script&lang=js&"
export * from "./DeleteLecturerModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteLecturerModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports